<template>
    <div class="fields-group">
        <p v-if="title">{{title}}</p>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'field-group-wrapper',
        props: {
            title: String
        },
    }
</script>

<style scoped>

</style>
